/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { me_MarkAllNotificationsReadResponse } from '../models/me_MarkAllNotificationsReadResponse';
import type { me_NotificationListResponse } from '../models/me_NotificationListResponse';
import type { me_NotificationPreferencesResponse } from '../models/me_NotificationPreferencesResponse';
import type { me_PushTokenResponse } from '../models/me_PushTokenResponse';
import type { me_RegisterPushTokenRequest } from '../models/me_RegisterPushTokenRequest';
import type { me_UpdateNotificationPreferencesRequest } from '../models/me_UpdateNotificationPreferencesRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MeService {
    /**
     * Get the caller's push notification preferences
     * Returns the effective per-kind push preferences for the calling user. A user who has never saved a preference set gets all-true defaults, and the read writes nothing.
     * @returns me_NotificationPreferencesResponse OK
     * @throws ApiError
     */
    public static getApiV1MeNotificationPreferences(): CancelablePromise<me_NotificationPreferencesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/notification-preferences',
            errors: {
                401: `Authentication required`,
                403: `Organization access denied`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update the caller's push notification preferences
     * Writes the calling user's per-kind push preferences. Every field is optional; an omitted field keeps its stored value, so a client may send a single changed flag. Turning pushEnabled off suppresses every kind. changeRequestDecision follows absenceDecision until it is sent once.
     * @param request Changed preference flags
     * @returns me_NotificationPreferencesResponse OK
     * @throws ApiError
     */
    public static putApiV1MeNotificationPreferences(
        request: me_UpdateNotificationPreferencesRequest,
    ): CancelablePromise<me_NotificationPreferencesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/me/notification-preferences',
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Organization access denied`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List the caller's in-app notifications
     * Returns the calling user's notification history, newest first, with the count of every unread row. A row exists for every notification the user was meant to receive, also when push was switched off or no device was registered. Rows carry text keys and a routing payload, never a child name or message content. Rows older than 90 days are deleted.
     * @param limit Page size (default 30, max 100)
     * @param offset Rows to skip (default 0)
     * @returns me_NotificationListResponse OK
     * @throws ApiError
     */
    public static getApiV1MeNotifications(
        limit?: number,
        offset?: number,
    ): CancelablePromise<me_NotificationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/notifications',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required`,
                403: `Organization access denied`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Mark one of the caller's notifications read
     * Marks one row of the calling user's history read. Marking a read row again succeeds and keeps the first read time. A row of another user answers 404.
     * @param id Notification id
     * @returns void
     * @throws ApiError
     */
    public static postApiV1MeNotificationsRead(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/notifications/{id}/read',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid id`,
                401: `Authentication required`,
                403: `Organization access denied`,
                404: `Notification not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Mark all of the caller's notifications read
     * Marks every unread row of the calling user's history read and returns how many changed.
     * @returns me_MarkAllNotificationsReadResponse OK
     * @throws ApiError
     */
    public static postApiV1MeNotificationsReadAll(): CancelablePromise<me_MarkAllNotificationsReadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/notifications/read-all',
            errors: {
                401: `Authentication required`,
                403: `Organization access denied`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Register this device for push notifications
     * Stores the calling user's Expo push token for one device. A second call for the same device refreshes the existing registration in place instead of creating a second one, so the client may call it on every launch. The organisation and the user are taken from the JWT, never from the body.
     * @param request Device push token registration
     * @returns me_PushTokenResponse Created
     * @throws ApiError
     */
    public static postApiV1MePushTokens(
        request: me_RegisterPushTokenRequest,
    ): CancelablePromise<me_PushTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/me/push-tokens',
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Organization access denied`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Unregister this device from push notifications
     * Retires the calling user's push token for one device on sign-out. The operation is idempotent: an unknown device also returns 204. The query is scoped by organisation, user and device, so a caller cannot delete another user's device even by guessing its id.
     * @param deviceId Stable per-install device identifier
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1MePushTokens(
        deviceId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/me/push-tokens/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Organization access denied`,
                500: `Internal server error`,
            },
        });
    }
}
